import React, { createContext, useState } from "react";

export const NavigationContext = createContext();

export default function NavigationProvider({ children }) {
  const [navigationOpen,   setNavigationOpen]   = useState(false);
  const [navigationExpend, setNavigationExpend] = useState(true); // true = geniş
  const [activeParent,     setActiveParent]     = useState("");
  const [activeChild,      setActiveChild]      = useState("");
  const [activeSubChild,   setActiveSubChild]   = useState("");

  return (
    <NavigationContext.Provider
      value={{
        navigationOpen,   setNavigationOpen,
        navigationExpend, setNavigationExpend,
        activeParent,     setActiveParent,
        activeChild,      setActiveChild,
        activeSubChild,   setActiveSubChild
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
}
